import watch   from "redux-watch";
import isEqual from 'is-equal';
export default class RiotEventManager {
  riotTag: riot.TagMixin;
  customEvents: Array<[string, (e) => void]> = [];
  reduxEvents: Array<() => void> = [];
  constructor(riotTag:riot.TagMixin){
    this.riotTag = riotTag;
    this.riotTag.on('unmount', () => { this.onUnmount(); })
  }
  customEvent(eventName: string, callback: (e) => void){
    this.customEvents.push([eventName, callback]);
    document.addEventListener(eventName, callback);
  }
  removeCustomEvent(eventName: string, callback: (e) => void){
    document.removeEventListener(eventName, callback);
  }
  reduxEvent(scope: string, callback:(newVal, oldVal, objectPath) => void){
    let w = watch(App.store.getState, scope, isEqual);
    let unsubscribe = App.store.subscribe(w(callback), true);
    this.reduxEvents.push(unsubscribe);
  }
  onUnmount(){
    for(let i=0;i<this.customEvents.length; i++){
      let eventName = this.customEvents[i][0];
      let callback = this.customEvents[i][1];
      document.removeEventListener(eventName, callback);
    }
    for(let i=0;i<this.reduxEvents.length; i++){
      let unsubscribe = this.reduxEvents[i];
      unsubscribe();
    }
  }
}
